import { Vue, Component, Watch } from 'vue-property-decorator';
import { isLoggedIn, logout } from '@/utils/auth';

@Component

export default class AppNav extends Vue {
  public isLoggedIn: boolean = isLoggedIn();

  public handleLogout(): void {
    logout();
  }

  @Watch('$route')
  private onPropertyChanged() {
    this.isLoggedIn = isLoggedIn();
  }
}
